import { render, staticRenderFns } from "./WatchlistSettings.vue?vue&type=template&id=14af32e6&"
import script from "./WatchlistSettings.vue?vue&type=script&lang=js&"
export * from "./WatchlistSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14af32e6')) {
      api.createRecord('14af32e6', component.options)
    } else {
      api.reload('14af32e6', component.options)
    }
    module.hot.accept("./WatchlistSettings.vue?vue&type=template&id=14af32e6&", function () {
      api.rerender('14af32e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/dialog/WatchlistSettings.vue"
export default component.exports